class Preview {

    constructor(playlistData) {
        // assign playlist data
        this._playlistData = playlistData;

        // current playing content index
        this.playlistIndex = -1;

        // Object content now playing
        this.scenePlaying = null;

        // Object next content for playback
        this.scenePreloading = null;
    }

    prepare(){
        let playlist =[],
            audioPlaylist = [];
        let widget = null;

        // sort items
        this._playlistData.medias.sort(function (a, b) {
            return a.sequence - b.sequence;
        });

        // walk each media
        for(let media of this._playlistData.medias){
            let mediaItem = {
                name: media.media.name,
                content: media.media.content,
                duration: media.duration,
                type: media.media.mediaType
            };
            switch (media.media.mediaType) {
                case "audio":
                    audioPlaylist.push(mediaItem);
                    break;
                case "html":
                    widget = mediaItem;
                    break;
                default:
                    playlist.push(mediaItem);
                    break;
            }
        }

        this.playlistData = {
            playlist: playlist,
            audioPlaylist: audioPlaylist,
            widget: widget
        }
    }

    start() {
        try {
            console.log("Starting playlist " + this._playlistData.name);

            // initialize widgets
            if(this.playlistData.widget){
                this.widget = new Widget(this.playlistData.widget.duration, this.playlistData.widget.content);
                this.widget.show();
            }

            // initialize audio player
            if(this.playlistData.audioPlaylist.length > 0){
                this.audioPlayer = new AudioPlayer(this.playlistData.audioPlaylist);
                this.audioPlayer.start();
            }

            // start marquee if text present
            if(this._playlistData.stripes.length > 0){
                this.stripe = new Stripe(this._playlistData.stripes[0]);
                this.stripe.start();
            }

            // show first content
            this.nextScene();
        } catch (e) {
            console.error("Player start error: " + e.message);
        }
    }

    nextScene() {
        const nextPlaylistIndex = this.nextPlaylistIndex();       // next loaded content
        console.log("Entering nextScene. Playlist indexes: " + this.playlistIndex + " => " + nextPlaylistIndex);

        // if(this.scenePlaying &&
        //     (nextPlaylistIndex === this.playlistIndex
        //     || nextPlaylistIndex === -1)){                       // one element in playlist, or no more loaded content yet
        //     console.debug("Single element");
        //     this.scenePlaying.start();                          // restart current content
        // } else {                                                // multiple items
        const nextContent = this.playlistData.playlist[nextPlaylistIndex];

        if(this.playlistData.playlist.length === 1){          // infinite loop
            nextContent.duration = 0;
        }

        console.log("Next content is: " + nextContent.name);
        this.playlistIndex = nextPlaylistIndex;
        if(this.scenePlaying === null){                         // start playing
            try {
                this.scenePlaying = this.sceneBuilder(nextContent);
                this.scenePlaying.start().then(msg => {
                    console.log(msg);
                    this.nextScene();
                });
                if(this.playlistData.playlist.length > 1) {
                    this.nextScene();
                }
            } catch (e) {
                console.error("nextScene [start playing] error: " + e.message);
            }
        } else if(this.scenePreloading === null) {              // haven't preloaded content yet
            try {
                this.scenePreloading = this.sceneBuilder(nextContent);
            } catch (e) {
                console.error("nextScene [preloading] error: " + e.message);
            }
        } else {
            try {
            this.scenePreloading.start().then(msg => { this.nextScene(); });  // show preloaded content
            this.scenePlaying.stop();                           // stop playing content
            this.scenePlaying = this.scenePreloading;           // swap variables
            this.scenePreloading = this.sceneBuilder(nextContent);
            } catch (e) {
                console.error("nextScene [content switch] error: " + e.message);
            }
        }

    }

    nextPlaylistIndex() {
        // increment counter
        let index = this.playlistIndex + 1;
        return (index === this.playlistData.playlist.length) ? 0 : index;
    }

    sceneBuilder(content) {
        try {
            // console.log("Building content: " + JSON.stringify(content));
            let contentURI = content.content,
                contentDuration = content.duration;

            console.log("Building content: " + content.name);

            switch (content.type) {
                case "image":
                    return new MediaImage(contentURI, contentDuration);
                case "video":
                    return new MediaVideo(contentURI, contentDuration);
                case "webPage":
                    return new MediaWebPage(contentURI, contentDuration);
            }
        } catch (e) {
            console.error("sceneBuilder error: " + e.message);
        }
    }
}
